module.exports = __webpack_public_path__ + "static/productToolBox-e7d553fa84da0570dda421c4c5f4ecde.png";